/* eslint-disable */
import axios from 'axios'

const initData = {
    getCityAirportNames(data){
        return new Promise(resolve=>{
            axios.post(
                '/api/GO/GetCityAirports',
                "codes=" + data
            ).then(rslt=>{
                resolve(rslt);
            }).catch(()=>{
            });
        });
    },
}

export default initData;